<!--普通公路养护管理系统-->
<template>
    <div class="system-container">
        <div class="section">
            <div class="section-content">
                <div class="title">平台概述</div>
                <p class="text">
                    利用先进的AI视觉算法，检测路面病害(横纵裂缝、龟裂、坑槽、抛洒物等)、交通安全设施损坏（交通标志牌、标线、护栏等）自动关联道路病害
                    的精确位置， 通过视频联动进行确认。 依靠路面病害识别算法，实时框选路面病害并进行参数的自动计算和标注，从而实现检测结果“可视”，对
                    于框选识别的病害实时并推 送至AI巡检云平台进行查看、统计分析、可视化展示， 生成巡检报告和病害清单，支持无缝对接智慧公路养护综合管
                    理平台，实现病害快速采集-派发养护任务 -养护施工-验收督察-计量支付全流程智能化、科学化、精细化管理。
                </p>
                <p class="text" style="margin-top: 0">
                    通过应用GIS一张图实现对道路巡查人员和养护人员、养护单位的动态管理与综合展示巡查轨迹、频率、里程、时常等巡查结果并形成规范性巡查台
                    账，对养护作业产生的人、机械、物料等相关费用明细一键生成、导出，为综合考评及月度养护经费拨付提供准确的数据依据。实现了人、机械、物
                    料、费用全面管控，有效提高养护质量，降低养护成本，节约养护资金。
                </p>
                <Carousel class="carousel" :images="imageList"/>
                <el-carousel class="mobile-carousel" height="200px" trigger="click">
                    <el-carousel-item v-for="(item,index) in imageList" :key="index">
                        <img
                            :src="item"
                            style="width: 100%;height: 100%;
                            object-fit: scale-down"
                            alt
                        />
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="section bg">
            <div class="section-content">
                <div class="title">核心功能</div>
                <div class="article">
                    <div class="tags left">
                        <div class="tag" style="transform: translateX(97px)">可视化驾驶舱</div>
                        <div class="tag" style="transform: translateX(58px)">专题”一张图“</div>
                        <div class="tag" style="transform: translateX(36px)">工作台</div>
                        <div class="tag" style="transform: translateX(28px)">基础数据</div>
                        <div class="tag" style="transform: translateX(36px)">路产路权</div>
                        <div class="tag" style="transform: translateX(58px)">自动化检测评定</div>
                        <div class="tag" style="transform: translateX(97px)">AI智能巡查</div>
                    </div>
                    <div class="tags right">
                        <div class="tag" style="transform: translateX(-137px)">日常养护</div>
                        <div class="tag" style="transform: translateX(-90px)">修复性养护</div>
                        <div class="tag" style="transform: translateX(-70px)">专项养护</div>
                        <div class="tag" style="transform: translateX(-70px)">应急养护</div>
                        <div class="tag" style="transform: translateX(-90px)">统计分析</div>
                        <div class="tag" style="transform: translateX(-137px)">系统设置</div>
                    </div>
                    <!--移动端适配-->
                    <div class="mobile-tags left">
                        <div class="tag" style="transform: translateX(16px)">可视化驾驶舱</div>
                        <div class="tag" style="transform: translateX(4px)">专题”一张图“</div>
                        <div class="tag" style="transform: translateX(-4px)">工作台</div>
                        <div class="tag" style="transform: translateX(-6px)">基础数据</div>
                        <div class="tag" style="transform: translateX(-4px)">路产路权</div>
                        <div class="tag" style="transform: translateX(4px)">自动化检测评定</div>
                        <div class="tag" style="transform: translateX(16px)">AI智能巡查</div>
                    </div>
                    <div class="mobile-tags right">
                        <div class="tag" style="transform: translateX(-18px)">日常养护</div>
                        <div class="tag" style="transform: translateX(-4px)">修复性养护</div>
                        <div class="tag" style="transform: translateX(2px)">专项养护</div>
                        <div class="tag" style="transform: translateX(2px)">应急养护</div>
                        <div class="tag" style="transform: translateX(-4px)">统计分析</div>
                        <div class="tag" style="transform: translateX(-18px)">系统设置</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section-content">
                <div class="title">应用价值</div>
                <div class="panel-content">
                    <div class="panel" v-for="(item,index) in panelList" :key="index">
                        <img class="img" :src="item.icon" alt="">
                        <div class="merit">
                            <div class="label">{{ item.label }}</div>
                            <div class="merit-text">
                                {{ item.text }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Carousel from "@/components/Carousel/index.vue";

export default {
    name: 'normalRoadMaintain',
    components: {Carousel},
    data() {
        return {
            imageList: [
                require('@/assets/image/prescription/sys_4.png'),
                require('@/assets/image/prescription/sys_5.png'),
                require('@/assets/image/prescription/sys_6.png')
            ],
            panelList: [
                {
                    icon: require('@/assets/image/prescription/icon_23.png'),
                    label: '强化农村公路资源管理 - 摸清家底',
                    text: '采用信息化手段对农村公路县、乡、村三级路网数据及公路交通安全设施、管理设施、服务设施、桥隧涵构造物等资产进行采集，并将采集数据纳入统一平台进行管理。可帮助农村公路管理单位“摸清家底”。'
                },
                {
                    icon: require('@/assets/image/prescription/icon_24.png'),
                    label: '强化农村公路路况检查 - 科学决策',
                    text: '按照农村公路管理办法的要求对农村公路进行路况检测与评定，将检测数据导入到平台进行评定分析，并生成养护建议报告，指导农村公路管理部门根据路面技术状况合理安排养护维修。'
                },
                {
                    icon: require('@/assets/image/prescription/icon_25.png'),
                    label: '强化养护人员队伍管理 - 提能增效',
                    text: '通过手机APP对公路养护人员巡查、养护过程中的工作状况进行登记，并实时记录人员轨迹，为管理人员进行绩效考评提供依据。也可将人员工作登记信息按周、按月导出养护工作日志报告，大大简化了内业工作。'
                },
                {
                    icon: require('@/assets/image/prescription/icon_26.png'),
                    label: '强化财产跟踪使用管理 - 优化配置',
                    text: '系统对养护人员巡查上报的病害数据进行智能分析，自动匹配养护方案，计算养护资金，管理人员可参考系统分析结果及现实资金情况合理编制养护计划，以使养护资金配置达到最优。'
                }
            ]
        };
    },
    mounted() {
    },
    methods: {
        //切换图片
        toggleImage(type) {
            this.$refs.carousel[type]();
        }
    }
};
</script>


<style scoped lang="scss">
.system-container {
    height: 100%;
    width: 100%;

    .bg {
        background-image: url("~@/assets/image/prescription/hxgn_bg.png");
    }

    .section {
        height: 100%;
        width: 100%;

        .section-content {
            margin: 0 auto;
            width: 1200px;
            padding: 50px 0;

            .title {
                text-align: center;
                font-size: 32px;
            }

            .text {
                margin-top: 40px;
                text-indent: 2em;
                line-height: 32px;
                font-size: 20px;
                text-align: justify;
            }

            .image {
                margin-top: 60px;
                width: 100%;
            }

            .mobile-carousel {
                display: none;
            }
        }
    }

    .article {
        margin-top: 80px;
        height: 560px;
        background-image: url("~@/assets/image/prescription/hxgn.png");
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;

        .mobile-tags {
            display: none;
        }

        .tags {
            padding: 40px 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .tag {
                font-size: 20px;
                min-width: 120px;
            }
        }

        .right {
            text-align: left;

            .tag {
                &::before {
                    margin-right: 24px;
                    content: '';
                    display: inline-block;
                    height: 12px;
                    width: 12px;
                    border-radius: 50%;
                    background: #0079FE;
                    box-shadow: 0 0 0 4px rgba(0, 121, 254, 0.2);
                }
            }
        }

        .left {
            text-align: right;

            .tag {
                &::after {
                    margin-left: 24px;
                    content: '';
                    display: inline-block;
                    height: 12px;
                    width: 12px;
                    border-radius: 50%;
                    background: #0079FE;
                    box-shadow: 0 0 0 4px rgba(0, 121, 254, 0.2);
                }
            }
        }


    }

    .panel-content {
        margin-top: 80px;
        width: 100%;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;

        .panel {
            width: calc(50% - 32px);
            margin-bottom: 32px;
            box-sizing: border-box;
            padding: 30px;
            border-radius: 4px;
            box-shadow: 0 3px 18px 1px rgba(26, 102, 187, 0.14);
            display: flex;

            .img{
                height: 100px;
                width: 100px;
            }

            .merit {
                padding: 4px 0 0 30px;



                .label {
                    font-size: 24px;
                    font-weight: bold;
                }

                .merit-text {
                    margin-top: 16px;
                    text-align: justify;
                    line-height: 30px;
                    font-size: 20px;
                }
            }

        }
    }
}

@import "./style.scss";
</style>
